import EEIdleState from "../../../vendor_core/states/EEIdleState";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import { TweenMax } from "gsap";
import InstanceFactory from "../../../vendor_core/core/src/factories/InstanceFactory";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import BBAnimationsHelper from "../../src/utils/BBAnimationsHelper";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import Locale from '../../../vendor_core/core/src/utils/Locale';
import AutoplayModel from '../../../vendor_core/core/src/model/AutoplayModel';
import RealityCheckModel from '../../../vendor_core/core/src/model/RealityCheckModel';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIStates } from '../../../vendor_core/core/src/ui/UIStates';
import { UIUpdateEvent } from '../../../vendor_core/core/src/ui/UIUpdateEvents';
import KeyboardManager, { Key } from '../../../vendor_core/core/src/utils/KeyboardManager';
import RelaxPOSTMessageController from '../../../vendor_core/server/RelaxPOSTMessageController';
import BBModel from '../model/BBModel';
import ConsoleUtil from '../../../vendor_core/core/src/utils/ConsoleUtil';

export class BBIdleState extends EEIdleState {
    protected autoSpinDelayCall: TweenMax = null;
    enter() {
        // SpinModel.currentWin = 0;
        // CommandManager.execute(Commands.UPDATE_WIN);
        super.enter();
        let layer = ViewManager.getLayer(DefaultLayers.Paylines).getCurrentScene()
        if (layer && layer.getSubView("wildEffect")) {
            layer.removeSubView("wildEffect")
        }
        //    BetModel.insufficientBalance = false;  // trollex(I don't find any logic)
        SoundController.playMusic(SoundVars.MUSIC_MAIN, undefined, true);

        // ViewManager.getLayer(DefaultLayers.Popups).setScene("freeGamesAwardedMultyChoice");

        // TEST -> show expand on start

        // this.playAllExpands();
        // UIController.setState(UIStates.AUTO);
    }

    protected applyStateSettings() {
        let activateSpinBtnDelay = this.getSpinDelayTime();
        this.setUIState(activateSpinBtnDelay - BBModel.autoplayDelay);

        if (AutoplayModel.isAutoSpinActive() && !GameModel.shouldPauseGame) {
            // ConsoleUtil.red("ENTER")
            this.autoSpinDelayCall = TweenMax.delayedCall(activateSpinBtnDelay, () => {
                this.spinIfInAutoplay();
            })
        }

        GameModel.restoreData = null;
        UIController.updateFields(UIUpdateEvent.All);

        if (GameModel.shouldPauseGame) {
            RelaxPOSTMessageController.reportPaused();
            UIController.setState(UIStates.SPIN);
            this.cleanDelayCall();
        }

        if (GameModel.hasRealityCheck) {
            let timeLeft = RealityCheckModel.getTimeTillTimeLimit();

            console.log("[BBIdleState] Reality check time left: " + timeLeft);

            if (timeLeft > 0) {
                this.realityCheckTimer = setTimeout(
                    this.forceRealityCheck.bind(this),
                    timeLeft
                );
            } else {
                this.forceRealityCheck();
            }
        }

        if (AutoplayModel.isAutoSpinActive()) {
            if (GameModel.shouldStopAutoplay) {
                GameModel.shouldStopAutoplay = false;
                AutoplayModel.setAutoSpin(0);
                this.cleanDelayCall();
            }
            return;
        }



        if (AutoplayModel.autoSpinLimitReached) {
            UIController.toggleComponent("autoplayLimitPopup");
            this.autoSpinDelayCall.kill();
        }

        if (!AutoplayModel.isAutoSpinActive()) {
            if (KeyboardManager.isPressed(Key.SPACE) && GameModel.alowSpaceToSkipSpin()) {
                this.spinWithKey();
            } else {
                KeyboardManager.onKey("pressed", Key.SPACE, this.spinWithKey, this);
            }
        }

    }

    protected cleanDelayCall() {
        if (this.autoSpinDelayCall) {
            this.autoSpinDelayCall.kill();
            this.autoSpinDelayCall = null;
        }
    }

    protected spinWithKey() {
        if (GameModel.spaceToSpin) {
            CommandManager.execute(Commands.SPIN);
        }
    }

    protected spinIfInAutoplay(): void {
        if (AutoplayModel.isAutoSpinActive()) {
            if (!GameModel.shouldStopAutoplay) {
                CommandManager.execute(Commands.SPIN);
            }
        }
    }

    protected setUIState(activateSpinBtnDelay: number): void {
        if (activateSpinBtnDelay <= 0) {
            // ConsoleUtil.red("SET_IDLE")
            UIController.setState(UIStates.IDLE);
        } else {
            KeyboardManager.disable()
            TweenMax.delayedCall(activateSpinBtnDelay, () => {
                UIController.setState(UIStates.IDLE);
                KeyboardManager.enable();
            });
        }
    }

    protected getSpinDelayTime(): number {
        let result = BBModel.spinStartTime;
        if (result !== 0) {
            let stopTime = Date.now();
            let spinEstimate =( (stopTime - BBModel.spinStartTime) / 1000);

            if (spinEstimate < GameModel.getMinSpineTimeByJurisdiction()) {
                result = Number((GameModel.getMinSpineTimeByJurisdiction() - spinEstimate).toFixed(2))
            } else {
                result = 0;
            }

            result += BBModel.autoplayDelay;
        }

        return result
    }

    public exit(): void {
        this.cleanDelayCall();
        super.exit()
    }
}
